import { H4 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { EventDeliveryListFallback } from '@/routes/webhook/tabs/event-deliveries/event-delivery-list/fallback'
import { EventDetailsFallback } from '@/routes/webhook/tabs/event-deliveries/event-details/fallback'

export const EventDeliveriesTabFallback = () => {
  return (
    <div className="grid grid-cols-2">
      <Card className="rounded-r-none">
        <CardHeader>
          <CardTitle>
            <H4>Events</H4>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <EventDeliveryListFallback />
        </CardContent>
      </Card>
      <Card className="rounded-l-none border-l-0 p-0">
        <CardContent className="p-0">
          <EventDetailsFallback />
        </CardContent>
      </Card>
    </div>
  )
}
